import { AssetListAsset } from 'src/@types/assets';
import { AssetSelectWithSearch } from 'src/components/Inputs/AssetSelectWithSearch';
import useAppEventEmitter from 'src/hooks/useAppEventEmitter';

interface LSTSelectListProps {
	assetList: AssetListAsset[];
	onSelect?: (selectedAsset: AssetListAsset) => void;
	source: 'wallet' | 'subaccount';
}

const LSTSelectList = ({ assetList, source, onSelect }: LSTSelectListProps) => {
	const appEventEmitter = useAppEventEmitter();

	const handleSelectAsset = (selectedAsset: AssetListAsset) => {
		appEventEmitter.emit('assetSelected', selectedAsset.mint);
		onSelect?.(selectedAsset);
	};

	return (
		<AssetSelectWithSearch
			assetList={assetList}
			onSelect={handleSelectAsset}
			source={source}
		/>
	);
};

export default LSTSelectList;
